export const C = {
  navy:"#1e2d4a", navyLight:"#2a3f64", teal:"#4a8fa8", tealLight:"#e8f4f8",
  sand:"#f5f2ee", text:"#1e2d4a", muted:"#6b7a90", border:"#dde3ea",
  white:"#ffffff", green:"#3a7d5a", greenLight:"#e8f5ee",
  orange:"#c87941", orangeLight:"#fdf0e6", red:"#b94a48", redLight:"#fdf0f0",
  purple:"#7b5ea7", purpleLight:"#f0edf8", yellow:"#b8960c", yellowLight:"#fdf9e6",
};
